import React, { useRef } from 'react'
import './about.css'
import one from '../../assets/AboutPics/1.png'
import two from '../../assets/AboutPics/5.png'
import three from '../../assets/AboutPics/3.png'
import resume from '../../assets/VincentCai_Resume.pdf'
import useIntersection from '../../hooks/useIntersection'

function About() {

  const ref = useRef();
  useIntersection(ref)

  return (
    <div className="about" id="about" ref={ref}>
      <div className="info">
        <h1>about.</h1>
        <h2>I'm a student at the University of Pennsylvania pursuing a <a href="https://www.cis.upenn.edu/graduate/program-offerings/mse-in-cis/" target="_blank" rel="noreferrer">MSE in Computer Science</a>.</h2>
        <br />
        <p><strong>I chase hard problems.</strong> I'm a former competitive programmer, through which I learned to think <u>thoroughly</u> and <u>critically</u>. In college, I've pushed myself into almost every corner of computer science, devling <u>as deeply as possible</u> into each one, to expose myself to the most interesting problems I could find. </p>
        <br />
        <p>
          I've managed 2 development teams and lead countless projects, and I have a strong understanding for the entire software development lifecycle. Currently my interests lay in <strong>distributed systems</strong>, <strong>low latency</strong>, and <strong>machine learning</strong>.
          {/* A problem solver at heart and a programmer with an algorithmic background, I enjoy finding elegant solutions to complex problems! */}
        </p>
        <br />
        {/* <p>When I'm not programming, I like to read, cook, play saxophone, or play/watch basketball (Go Sixers!).</p> */}
      </div>
      {/* <div className="picture">
        <img src={two} alt="" />
        <img src={one} alt="" />
        <img src={three} alt="" />
      </div> */}
    </div >
  )
}

export default About
